import { Map } from 'immutable'
import * as actionTypes from '../actions/actionTypes'

const initialState = Map({
  inputDisabled: false,
  blink: false,
  blinkColor: '',
  dropdownInput: false,
  dropdownOptions: [],
  dateInput: false,
  isFetching: false,
  showChat: false,
  defaultSenderPlaceHolder: 'Type a message or select an option.',
  senderPlaceHolder: null,
  showTOC: false,
  clearInput: false
})

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.TOGGLE_CHAT: {
      return state.update('showChat', showChat => !showChat)
    }
    case actionTypes.OPEN_CHAT: {
      return state.set('showChat', true)
    }
    case actionTypes.CLOSE_CHAT: {
      return state.set('showChat', false)
    }
    case actionTypes.SET_IS_FETCHING: {
      return state.set('isFetching', action.payload)
    }
    case actionTypes.SET_INPUT_DISABLED: {
      return state.set('inputDisabled', action.payload)
    }
    case actionTypes.SET_BLINK: {
      return state.set('blink', action.payload)
    }
    case actionTypes.SET_BLINK_COLOR: {
      return state.set('blinkColor', action.payload)
    }
    case actionTypes.SET_INPUT_DROPDOWNTYPE: {
      return state.set('dropdownInput', action.payload)
    }
    case actionTypes.SET_INPUT_DROPDOWN_OPTIONS: {
      return state.set('dropdownOptions', action.payload)
    }
    case actionTypes.SET_INPUT_DATETYPE: {
      return state.set('dateInput', action.payload)
    }
    case actionTypes.RESET_CHAT: {
      return initialState.set('showChat', true)
    }
    case actionTypes.SET_SENDER_PLACEHOLDER: {
      return state.set('senderPlaceHolder', action.payload)
    }
    case actionTypes.TOGGLE_TOC: {
      return state.update('showTOC', showTOC => !showTOC)
    }
    case actionTypes.CLEAR_INPUT: {
      return state.set('clearInput', action.payload)
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ChatWidget/store/reducers/behaviorReducer.js